// extracted by mini-css-extract-plugin
export default {"content_list":"index_content_list_UIS59","content_list_item":"index_content_list_item_nw6CN","chip_item":"index_chip_item_9hUEM","top_40":"index_top_40_2HlGZ"};